import React from 'react'
//import Button from './Button'
import CookieConsent from 'react-cookie-consent'
import './Cookies.css'

function Cookies() {
    return (
        <div>
        <CookieConsent 
            location="bottom"
            style={{
                position:"fixed",
                display:"flex",
                flexDirection:"row",
                alignItems:"center",
                width:"85%",
                maxWidth:"1240px",
                padding:"16px 20px",
                background:"#FFFFFF",
                boxShadow:"4px 4px 4px rgba(0, 0, 12, 0.1)",
                borderRadius:"4px",
                left:"88px",
                margin:"146px auto",
                
                transition:"400ms cubic-bezier(0.22, 0.61, 0.36, 1)",
                color:"rgba(0, 0, 12, 0.5)",
                fontFamily:"PPPangramSansRounded-Medium",
                fontSize:"12px",
                lineHeight:"20px",
                maxWidth:"100%",
            }}
            buttonText="Aceptar Todas"
            buttonStyle={{
                marginLeft:"66px",
                fontFamily:"PPPangramSansRounded-Semibold",
                color:"rgba(255, 255, 255, 1)",
                backgroundColor:"rgba(0,213,99,1)",
                borderRadius:"86px",
                padding:"9px 16px",
                fontSize:"14px"

            }}
        >
            Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso. Puede cambiar la configuración u obtener más información <a href="/">aquí</a>.
             
        </CookieConsent>
            {/*<div className="cookiesContent">
                <p className="cookiesContent">Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso. Puede cambiar la configuración u obtener más información aquí (enlace a página de cookies).</p>
            </div>
            <div className="cookiesBtn">
                <Button contacto="Aceptar"/>
            </div>
            <div className="cookiesBtnMain">
                <ButtonMain mainbtn="Aceptar todas"/>
            </div>*/}
        </div>
    )
}

export default Cookies
